import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { InvestorCommunicationInfo } from "../../../api/types/investorCommunicationsTypes";
import InvestorCommunicationsPageContext from "./InvestorCommunicationsPageContext";
import { getPublishTransition, getUnpublishTransition } from "./investorCommunicationStatusHelper";

interface Props {
  communication: InvestorCommunicationInfo;
}

const InvestorCommunicationsGridActionsCell = ({ communication }: Props) => {
  const { hasEditPermissions, isNewsVisibleToInvestors, onStatusChange, onDelete } = useDefinedContext(
    InvestorCommunicationsPageContext,
    "InvestorCommunicationsPageContext"
  );

  if (!hasEditPermissions) {
    return null;
  }

  const publishTransition = getPublishTransition(communication.status, isNewsVisibleToInvestors);
  const unpublishTransition = getUnpublishTransition(communication.status);
  const { isReadyForPublishing } = communication;

  return (
    <ActionsMenuButton
      items={[
        {
          hidden: publishTransition === undefined,
          label: publishTransition?.label,
          icon: publishTransition && <publishTransition.Icon />,
          disabled: !isReadyForPublishing,
          tooltip: isReadyForPublishing
            ? undefined
            : "Add at least one fund and category, a title and content before publishing",
          onClick: () => publishTransition && onStatusChange(communication, publishTransition),
        },
        {
          hidden: unpublishTransition === undefined,
          label: unpublishTransition?.label,
          icon: unpublishTransition && <unpublishTransition.Icon />,
          onClick: () => unpublishTransition && onStatusChange(communication, unpublishTransition),
        },
        { label: "Delete", icon: <DeleteIcon color="error" />, onClick: () => onDelete(communication) },
      ]}
    />
  );
};

export default InvestorCommunicationsGridActionsCell;
